import { set } from "@/utils/vuex";

export default {
  setContributions: set("contributions"),
  setType: set("siteType"),
  setToolbarSearchText: set("toolbarSearchText"),
  clearToolbarSearchText: (state) => {
    state.toolbarSearchText = "";
  }
};
